"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var Column = function Column(_ref) {
  var prefixCls = _ref.prefixCls,
      icon = _ref.icon,
      title = _ref.title,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      style = _ref.style,
      className = _ref.className;
  return react_1.default.createElement("div", {
    className: classnames_1.default("".concat(prefixCls, "-column"), className),
    style: style
  }, (title || icon) && react_1.default.createElement("h2", null, icon && react_1.default.createElement("span", {
    className: "".concat(prefixCls, "-column-icon")
  }, icon), title), items.map(function (item, i) {
    var LinkComponent = item.LinkComponent || 'a';
    return react_1.default.createElement("div", {
      className: classnames_1.default("".concat(prefixCls, "-item"), item.className),
      style: item.style,
      key: i
    }, react_1.default.createElement(LinkComponent, {
      href: item.url,
      to: typeof LinkComponent !== 'string' ? item.url : undefined,
      target: item.openExternal ? '_blank' : undefined,
      rel: item.openExternal ? 'noopener noreferrer' : undefined
    }, item.icon && react_1.default.createElement("span", {
      className: "".concat(prefixCls, "-item-icon")
    }, item.icon), item.title), item.description && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("span", {
      className: "".concat(prefixCls, "-item-separator")
    }, "-"), react_1.default.createElement("span", {
      className: "".concat(prefixCls, "-item-description")
    }, item.description)));
  }));
};

exports.default = Column;